import React from 'react';
import styled from 'styled-components/macro';
import { fontFamily } from '@podiumhq/podium-ui';

const GlobalStyles = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

const Wrapper = styled.div`
  * {
    font-family: ${fontFamily};
  }
`;

export default GlobalStyles;
